export default __webpack_public_path__ + "static/media/dp-injec-ntecore.70083caf.png";